export default __webpack_public_path__ + "locales/pt-BR/BackupCodesDialog.json?hash=beb842f545ebeccb53e7104ac2fefb0a";